var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { compareVersions, getAppKey, isIOS, isAndroid, greaterThanOrEqualTo, getShareInfoUrl, shareCallbackV0ToV1, getDefaultShareText, getShareImagePreviewUrl, isYuanTiKu, getItem, setItem, v0ListToV1, v1ToV0, dispatchEvent, getAppVersion } from './utils/util';
import Config from './config';
import { ERRORS } from './constants/errors';
import { getUserId } from './services/user';
import { sendMessage, sendMessageWithCallback } from '@solar/solar-web-bridge';
import { VERSION, ua, APP_UA, DEVICES, SHARE_TYPE, LEFT_BUTTON_CLICK_EVENT, RIGHT_BUTTON_CLICK_EVENT, SHARE_EVENT, LOGIN_EVENT, REFRESH_STATE } from './constants/constant';
var globalScope = window;
globalScope.box = {};
var V0 = VERSION.V0, V1 = VERSION.V1, V1_2_0 = VERSION.V1_2_0, V1_3_0 = VERSION.V1_3_0, V1_4_0 = VERSION.V1_4_0, V1_6_0 = VERSION.V1_6_0, V1_8_1 = VERSION.V1_8_1, V1_9_0 = VERSION.V1_9_0;
export var getWebViewInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a, err, extData;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!!globalScope.box.webviewInfo) return [3 /*break*/, 2];
                return [4 /*yield*/, sendMessage('getWebViewInfo', { trigger: true }, 0, 'common').catch(function (errInfo) {
                        return errInfo;
                    })];
            case 1:
                _a = _b.sent(), err = _a.err, extData = _a.extData;
                if (err && err !== ERRORS.METHOD_NOT_SUPPORT) {
                    throw err;
                }
                if (err === ERRORS.METHOD_NOT_SUPPORT) {
                    globalScope.box.webviewInfo = { version: V0 };
                }
                if (!err) {
                    globalScope.box.webviewInfo = extData[0];
                }
                _b.label = 2;
            case 2: return [2 /*return*/, globalScope.box.webviewInfo];
        }
    });
}); };
var available = function (readyParams) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, params, exceptedVersion, _b, supportedApps, _c, excludeApps, _d, requiredParams, webviewVersion, appKey, _e, _f, version, _g, device;
    return __generator(this, function (_h) {
        switch (_h.label) {
            case 0:
                _a = readyParams.params, params = _a === void 0 ? {} : _a, exceptedVersion = readyParams.exceptedVersion, _b = readyParams.supportedApps, supportedApps = _b === void 0 ? [] : _b, _c = readyParams.excludeApps, excludeApps = _c === void 0 ? {} : _c, _d = readyParams.requiredParams, requiredParams = _d === void 0 ? [] : _d;
                // 检查是否缺少必要的参数
                if (!requiredParams.every(function (key) { return !!params[key]; })) {
                    return [2 /*return*/, false];
                }
                return [4 /*yield*/, getWebViewInfo()];
            case 1:
                webviewVersion = (_h.sent()).version;
                if (compareVersions(webviewVersion, exceptedVersion) < 0) {
                    return [2 /*return*/, false];
                }
                // 判断支持的app
                if (supportedApps.length > 0 && !supportedApps.find(function (appUa) {
                    ua.includes(appUa) && (appUa !== APP_UA.SOLAR || !ua.includes(APP_UA.LEO));
                })) {
                    return [2 /*return*/, false];
                }
                appKey = getAppKey();
                if (excludeApps[appKey]) {
                    _e = excludeApps[appKey], _f = _e.version, version = _f === void 0 ? '' : _f, _g = _e.device, device = _g === void 0 ? '' : _g;
                    if (((device === DEVICES.ANDROID && isAndroid()) || (device === DEVICES.IOS && isIOS()))
                        && (version && !greaterThanOrEqualTo(version))) {
                        return [2 /*return*/, false];
                    }
                }
                return [2 /*return*/, true];
        }
    });
}); };
var exec = function (name, apiParams, oldName, prefix) {
    if (prefix === void 0) { prefix = ''; }
    return __awaiter(void 0, void 0, void 0, function () {
        var V0, V1, _a, timeout, validParams, oldValidParams, _b, _c, sendParams;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    V0 = apiParams.V0, V1 = apiParams.V1, _a = apiParams.timeout, timeout = _a === void 0 ? 0 : _a, validParams = apiParams.validParams, oldValidParams = apiParams.oldValidParams;
                    _b = V1;
                    if (!_b) return [3 /*break*/, 2];
                    return [4 /*yield*/, available(__assign(__assign({}, validParams), { exceptedVersion: V1 }))];
                case 1:
                    _b = (_d.sent());
                    _d.label = 2;
                case 2:
                    if (_b) {
                        return [2 /*return*/, sendMessage(name, validParams === null || validParams === void 0 ? void 0 : validParams.params, timeout, prefix || 'common').then(function (response) {
                                return __assign(__assign({}, response), { version: V1 });
                            }).catch(function (errInfo) {
                                return Promise.reject(__assign(__assign({}, errInfo), { version: V1 }));
                            })];
                    }
                    _c = V0;
                    if (!_c) return [3 /*break*/, 4];
                    return [4 /*yield*/, available(__assign(__assign({}, (oldValidParams || validParams)), { exceptedVersion: V0 }))];
                case 3:
                    _c = (_d.sent());
                    _d.label = 4;
                case 4:
                    if (_c) {
                        sendParams = (oldValidParams === null || oldValidParams === void 0 ? void 0 : oldValidParams.params) || (validParams === null || validParams === void 0 ? void 0 : validParams.params);
                        return [2 /*return*/, sendMessage(oldName || name, sendParams, timeout, prefix).then(function (response) {
                                return __assign(__assign({}, response), { version: V0 });
                            }).catch(function (errInfo) {
                                return Promise.reject(__assign(__assign({}, errInfo), { version: V0 }));
                            })];
                    }
                    return [2 /*return*/, Promise.reject({
                            V0: V0,
                            err: ERRORS.METHOD_NOT_SUPPORT,
                            extData: []
                        })];
            }
        });
    });
};
var execWithCallback = function (name, apiParams, oldName, prefix) {
    if (prefix === void 0) { prefix = ''; }
    return __awaiter(void 0, void 0, void 0, function () {
        var V0, V1, _a, timeout, validParams, oldValidParams, _b, _c, sendParams, sendParams, _d, trigger, shareTrigger, callback;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    V0 = apiParams.V0, V1 = apiParams.V1, _a = apiParams.timeout, timeout = _a === void 0 ? 0 : _a, validParams = apiParams.validParams, oldValidParams = apiParams.oldValidParams;
                    _b = V1;
                    if (!_b) return [3 /*break*/, 2];
                    return [4 /*yield*/, available(__assign(__assign({}, validParams), { exceptedVersion: V1 }))];
                case 1:
                    _b = (_e.sent());
                    _e.label = 2;
                case 2:
                    if (!_b) return [3 /*break*/, 3];
                    sendMessageWithCallback(name, validParams === null || validParams === void 0 ? void 0 : validParams.params, timeout, prefix || 'common');
                    return [3 /*break*/, 6];
                case 3:
                    _c = V0;
                    if (!_c) return [3 /*break*/, 5];
                    return [4 /*yield*/, available(__assign(__assign({}, (oldValidParams || validParams)), { exceptedVersion: V0 }))];
                case 4:
                    _c = (_e.sent());
                    _e.label = 5;
                case 5:
                    if (_c) {
                        sendParams = (oldValidParams === null || oldValidParams === void 0 ? void 0 : oldValidParams.params) || (validParams === null || validParams === void 0 ? void 0 : validParams.params);
                        sendMessageWithCallback(oldName || name, sendParams, timeout, prefix);
                    }
                    else {
                        sendParams = (oldValidParams === null || oldValidParams === void 0 ? void 0 : oldValidParams.params) || (validParams === null || validParams === void 0 ? void 0 : validParams.params);
                        _d = sendParams, trigger = _d.trigger, shareTrigger = _d.shareTrigger, callback = _d.callback;
                        trigger(ERRORS.METHOD_NOT_SUPPORT);
                        shareTrigger(ERRORS.METHOD_NOT_SUPPORT);
                        callback(ERRORS.METHOD_NOT_SUPPORT);
                    }
                    _e.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    });
};
export var setTitle = function (title) {
    return exec('setTitle', {
        V0: V0,
        V1: V1,
        validParams: {
            params: {
                title: title
            }
        }
    });
};
export var setLeftButton = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var trigger;
    return __generator(this, function (_a) {
        trigger = params.trigger;
        execWithCallback('setLeftButton', {
            V0: V0,
            V1: V1,
            validParams: {
                params: __assign(__assign(__assign({}, params), (trigger && { trigger: function cb() {
                        var response = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            response[_i] = arguments[_i];
                        }
                        var err = response[0], extData = response.slice(1);
                        dispatchEvent(LEFT_BUTTON_CLICK_EVENT, extData[0]);
                        trigger(err);
                    }
                })), { hidden: !!params.hidden })
            }
        });
        return [2 /*return*/];
    });
}); };
export var setRightButton = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var trigger;
    return __generator(this, function (_a) {
        trigger = params.trigger;
        execWithCallback('setRightButton', {
            V0: V0,
            V1: V1,
            validParams: {
                params: __assign(__assign(__assign({}, params), (trigger && {
                    trigger: function cb() {
                        var response = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            response[_i] = arguments[_i];
                        }
                        var err = response[0], extData = response.slice(1);
                        dispatchEvent(RIGHT_BUTTON_CLICK_EVENT, extData[0]);
                        trigger(err);
                    }
                })), { hidden: !!params.hidden })
            }
        });
        return [2 /*return*/];
    });
}); };
export var toast = function (message) {
    return exec('toast', {
        V0: V0,
        V1: V1,
        validParams: {
            params: {
                message: message
            }
        }
    });
};
export var closeWebView = function () {
    return exec('closeWebView', {
        V0: V0,
        V1: V1
    });
};
export var previewImage = function (params) {
    return exec('previewImage', {
        V0: V0,
        V1: V1,
        validParams: {
            params: params
        }
    });
};
export var jsLoadComplete = function (params) {
    return exec('jsLoadComplete', {
        V0: V0,
        V1: V1,
        validParams: {
            params: params
        }
    });
};
export var openSchema = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var trigger, tmpParams, _a, version, err, extData, result_1, isSuccess;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                trigger = params.trigger;
                tmpParams = __assign(__assign({}, params), { schemas: JSON.parse(JSON.stringify(params.schemas)) });
                if (!tmpParams.schemas.length) {
                    if (typeof trigger === 'string' && typeof globalScope[trigger] === 'function') {
                        globalScope[trigger](ERRORS.OPEN_SCHEMA_NO_MATCHED_PAGE);
                    }
                    if (typeof trigger === 'function') {
                        trigger(ERRORS.OPEN_SCHEMA_NO_MATCHED_PAGE);
                    }
                    throw new Error("ERRORS.OPEN_SCHEMA_NO_MATCHED_PAGE");
                }
                return [4 /*yield*/, exec('openSchema', {
                        V0: V0,
                        V1: V1,
                        validParams: {
                            params: tmpParams,
                        },
                        oldValidParams: {
                            params: __assign(__assign({}, tmpParams), { schema: tmpParams.schemas[0], trigger: false, callback: true })
                        }
                    }).catch(function (errInfo) {
                        return errInfo;
                    })];
            case 1:
                _a = _b.sent(), version = _a.version, err = _a.err, extData = _a.extData;
                if (version === V0) {
                    result_1 = extData[0];
                    isSuccess = (function () {
                        if (isIOS()) {
                            return !err;
                        }
                        else {
                            return result_1 === '成功';
                        }
                    })();
                    if (isSuccess) {
                        typeof trigger === 'function' && trigger(ERRORS.NULL);
                        typeof trigger === 'string' &&
                            typeof window[trigger] === 'function' &&
                            globalScope[trigger](ERRORS.NULL);
                    }
                    else {
                        tmpParams.schemas.shift();
                        openSchema(tmpParams);
                    }
                }
                else {
                    trigger(err);
                }
                return [2 /*return*/];
        }
    });
}); };
export var setOnVisibilityChange = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (available({
            exceptedVersion: V1
        })) {
            sendMessageWithCallback('setOnVisibilityChange', params, 0, 'common');
        }
        return [2 /*return*/];
    });
}); };
export var showShareWindow = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var trigger, oldCaseParams;
    return __generator(this, function (_a) {
        trigger = params.trigger;
        oldCaseParams = __assign(__assign(__assign({}, (params.shareInfoJson && !params.shareInfoUrl && {
            shareInfoUrl: getShareInfoUrl(params.shareInfoJson, 'link'),
        })), (params.shareInfoJson && {
            shareInfoJson: JSON.stringify(__assign(__assign({}, params.shareInfoJson), { shareType: SHARE_TYPE.LINK })),
        })), (trigger && {
            shareTrigger: function () {
                var response = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    response[_i] = arguments[_i];
                }
                var err = response[0], channel = response[1];
                typeof trigger === 'function' && trigger(err, shareCallbackV0ToV1(channel));
                typeof trigger === 'string' &&
                    typeof globalScope[trigger] === 'function' &&
                    globalScope[trigger](err, shareCallbackV0ToV1(channel));
                dispatchEvent(SHARE_EVENT, channel);
            }
        }));
        execWithCallback('showShareWindow', {
            V0: V0,
            V1: V1,
            validParams: {
                params: __assign(__assign({}, params), (trigger && {
                    trigger: function () {
                        var response = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            response[_i] = arguments[_i];
                        }
                        var err = response[0], extData = response.slice(1);
                        dispatchEvent(SHARE_EVENT, extData[0]);
                        trigger(err, extData[0]);
                    }
                }))
            },
            oldValidParams: {
                params: oldCaseParams
            }
        }, 'setShareWindow2');
        return [2 /*return*/];
    });
}); };
export var shareAsImage = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var trigger, shareInfoJson, shareInfoUrl, oldCaseParams, _a, err, extData, version, channel;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                trigger = params.trigger;
                shareInfoJson = __assign(__assign({}, getDefaultShareText()), { url: getShareImagePreviewUrl(params.imageUrl), jumpUrl: getShareImagePreviewUrl(params.imageUrl), thumbUrl: params.imageUrl, imageUrl: params.imageUrl });
                if (params.text) {
                    shareInfoJson.text = params.text;
                }
                shareInfoUrl = getShareInfoUrl(shareInfoJson, 'image');
                oldCaseParams = __assign(__assign({}, (params.imageUrl && {
                    shareInfoUrl: shareInfoUrl,
                    shareInfoJson: JSON.stringify(__assign(__assign({}, shareInfoJson), { shareType: 1 })),
                })), (trigger && {
                    shareTrigger: true
                }));
                return [4 /*yield*/, exec('shareAsImage', {
                        V0: V0,
                        V1: V1,
                        validParams: {
                            params: __assign(__assign({}, params), { trigger: !!trigger })
                        },
                        oldValidParams: {
                            params: oldCaseParams,
                            supportedApps: [APP_UA.SOLAR, APP_UA.APE, APP_UA.LEO],
                            requiredParams: ['imageUrl']
                        }
                    }, 'setShareWindow2').catch(function (errInfo) {
                        return errInfo;
                    })];
            case 1:
                _a = _b.sent(), err = _a.err, extData = _a.extData, version = _a.version;
                if (trigger) {
                    if (V1 === version && typeof trigger === 'function') {
                        trigger(err, extData);
                        dispatchEvent(SHARE_EVENT, extData[0]);
                    }
                    else if (version === V0) {
                        channel = (extData || {}).channel;
                        typeof trigger === 'function' && trigger(ERRORS.NULL, shareCallbackV0ToV1(channel));
                        typeof trigger === 'string' &&
                            typeof globalScope[trigger] === 'function' &&
                            globalScope[trigger](ERRORS.NULL, shareCallbackV0ToV1(channel));
                    }
                }
                return [2 /*return*/, extData];
        }
    });
}); };
export var openWebView = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var trigger, _a, err, extData;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                trigger = params.trigger;
                return [4 /*yield*/, exec('openWebView', {
                        V0: V0,
                        V1: V1,
                        validParams: {
                            params: params
                        }
                    }).catch(function (errInfo) {
                        return errInfo;
                    })];
            case 1:
                _a = _b.sent(), err = _a.err, extData = _a.extData;
                trigger(err, extData[0]);
                return [2 /*return*/];
        }
    });
}); };
export var capture = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var newParams, extData, localPath, imageUrl;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newParams = __assign({ trigger: true }, params);
                return [4 /*yield*/, exec('capture', {
                        V0: V0,
                        V1: V1,
                        validParams: {
                            params: newParams
                        },
                        oldValidParams: {
                            supportedApps: [APP_UA.TUTOR]
                        }
                    })];
            case 1:
                extData = (_a.sent()).extData;
                localPath = extData[0], imageUrl = extData[1];
                return [2 /*return*/, {
                        localPath: localPath,
                        imageUrl: imageUrl
                    }];
        }
    });
}); };
export var getUserInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a, err, extData, userInfo, appVersion, versionDiff, userId;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, exec('getUserInfo', {
                    V1: V1,
                    validParams: {
                        params: {
                            trigger: true
                        }
                    }
                }).catch(function (errInfo) {
                    return errInfo;
                })];
            case 1:
                _a = _b.sent(), err = _a.err, extData = _a.extData;
                dispatchEvent(LOGIN_EVENT, extData[0]);
                if (err) {
                    throw err;
                }
                userInfo = extData[0];
                if (!isIOS()) return [3 /*break*/, 4];
                appVersion = getAppVersion();
                versionDiff = compareVersions(appVersion, '10.14.0');
                if (!(versionDiff < 1)) return [3 /*break*/, 3];
                return [4 /*yield*/, getUserId()];
            case 2:
                userId = _b.sent();
                userInfo.userId = userId.id;
                _b.label = 3;
            case 3:
                // 兼容ios实现和文档不一样的问题，为了防止使用者迷惑，就不把nickname写在IUserInfo
                if (userInfo.nickname) {
                    userInfo.nickName = userInfo.nickname;
                    delete userInfo.nickname;
                }
                _b.label = 4;
            case 4: return [2 /*return*/, userInfo];
        }
    });
}); };
export var login = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, exec('login', {
                    V0: V0,
                    V1: V1,
                    validParams: {
                        params: __assign({ trigger: true }, params)
                    },
                    oldValidParams: {
                        params: {
                            callback: isYuanTiKu() && isIOS()
                        }
                    }
                })];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, , 4, 5]);
                return [4 /*yield*/, getUserInfo()];
            case 3:
                _a.sent();
                return [3 /*break*/, 5];
            case 4: return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
export var getImmerseStatusBarHeight = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a, err, extData;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, exec('getImmerseStatusBarHeight', {
                    V0: V0,
                    V1: V1,
                    validParams: {
                        params: {
                            trigger: true
                        }
                    },
                    oldValidParams: {
                        params: {
                            callback: true
                        }
                    }
                }, 'getStatusBarHeight').catch(function (errInfo) {
                    return errInfo;
                })];
            case 1:
                _a = _b.sent(), err = _a.err, extData = _a.extData;
                if (err) {
                    throw err;
                }
                return [2 /*return*/, extData[0]];
        }
    });
}); };
export var pay = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, exec('pay', {
                V0: V0,
                V1: V1,
                validParams: {
                    params: __assign(__assign({}, params), { trigger: true })
                }
            }, 'pay2')];
    });
}); };
export var chooseImage = function (count) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, err, extData, localPaths, localContents;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, exec('chooseImage', {
                    V0: V0,
                    V1: V1,
                    validParams: {
                        params: {
                            trigger: true,
                            count: count
                        }
                    },
                    oldValidParams: {
                        supportedApps: [APP_UA.SOLAR, APP_UA.APE, APP_UA.TUTOR]
                    }
                }).catch(function (errInfo) {
                    return errInfo;
                })];
            case 1:
                _a = _b.sent(), err = _a.err, extData = _a.extData;
                if (err) {
                    throw err;
                }
                localPaths = extData[0], localContents = extData[1];
                return [2 /*return*/, __assign({ localPaths: localPaths }, (localContents && localContents.length && {
                        localContents: localContents
                    }))];
        }
    });
}); };
export var camera = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a, err, extData;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, exec('camera', {
                    V0: V0,
                    V1: V1,
                    validParams: {
                        params: {
                            trigger: true
                        }
                    },
                    oldValidParams: {
                        supportedApps: [APP_UA.SOLAR, APP_UA.APE, APP_UA.TUTOR]
                    }
                }).catch(function (errInfo) {
                    return errInfo;
                })];
            case 1:
                _a = _b.sent(), err = _a.err, extData = _a.extData;
                if (err) {
                    throw err;
                }
                return [2 /*return*/, extData[0]];
        }
    });
}); };
export var uploadImage = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var extData, imageMeta;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (getItem(params.localPath)) {
                    return [2 /*return*/, JSON.parse(getItem(params.localPath))];
                }
                return [4 /*yield*/, exec('uploadImage', {
                        V0: V0,
                        V1: V1,
                        validParams: {
                            params: __assign(__assign({}, params), { trigger: true })
                        }
                    })];
            case 1:
                extData = (_a.sent()).extData;
                imageMeta = extData[0];
                setItem(params.localPath, JSON.stringify(imageMeta));
                return [2 /*return*/, imageMeta];
        }
    });
}); };
export var getShareList = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a, version, extData, shareList;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, exec('getShareList', {
                    V0: V0,
                    V1: V1,
                    validParams: {
                        params: {
                            trigger: true
                        }
                    },
                    oldValidParams: {
                        params: {
                            callback: true
                        }
                    }
                })];
            case 1:
                _a = _b.sent(), version = _a.version, extData = _a.extData;
                shareList = extData[0];
                if (version === V1) {
                    return [2 /*return*/, shareList];
                }
                return [2 /*return*/, v0ListToV1(shareList)];
        }
    });
}); };
export var doShare = function (params) {
    execWithCallback('doShare', {
        V0: V0,
        V1: V1,
        validParams: {
            params: params
        },
        oldValidParams: {
            params: __assign(__assign(__assign(__assign({}, params), (params.shareInfoJson && !params.shareInfoUrl && {
                shareInfoUrl: getShareInfoUrl(params.shareInfoJson, 'link'),
            })), (params.shareInfoJson && {
                shareInfoJson: JSON.stringify(__assign(__assign({}, params.shareInfoJson), { shareType: SHARE_TYPE.LINK })),
            })), { type: v1ToV0(params.type) }),
            supportedApps: [APP_UA.SOLAR, APP_UA.APE, APP_UA.LEO]
        }
    });
};
export var doShareAsImage = function (params) {
    var _a;
    var share = function () {
        var shareInfoJson = __assign(__assign({}, getDefaultShareText()), { url: getShareImagePreviewUrl(params.imageUrl), jumpUrl: getShareImagePreviewUrl(params.imageUrl), thumbUrl: params.imageUrl, imageUrl: params.imageUrl });
        if (params.text) {
            shareInfoJson.text = params.text;
        }
        var oldValidParams = {
            params: __assign(__assign({}, params), { shareInfoUrl: getShareInfoUrl(shareInfoJson, 'image'), shareInfoJson: JSON.stringify(__assign(__assign({}, shareInfoJson), { shareType: 1 })), type: v1ToV0(params.type) }),
            supportedApps: [APP_UA.SOLAR, APP_UA.APE, APP_UA.LEO]
        };
        return execWithCallback('doShareAsImage', {
            V0: V0,
            V1: V1,
            validParams: {
                params: params,
            },
            oldValidParams: oldValidParams
        });
    };
    available({
        exceptedVersion: V1,
        excludeApps: (_a = {},
            _a[APP_UA.SOLAR] = { version: '9.3.0', device: DEVICES.ANDROID },
            _a[APP_UA.APE] = { version: '8.12.0', device: DEVICES.ANDROID },
            _a[APP_UA.LEO] = { version: '2.21.0', device: DEVICES.ANDROID },
            _a)
    }).then(function (isAvailable) {
        if (!isAvailable && !params.imageUrl) {
            uploadImage({
                localPath: params.imagePath,
            }).then(function (imageMeta) {
                params.imageUrl = Config.GALLERY_HOST + imageMeta.imageId;
                share();
            });
        }
        else {
            share();
        }
    });
};
export var base64ToLocalPath = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var extData, localPath;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, exec('base64ToLocalPath', {
                    V1: V1,
                    validParams: {
                        params: {
                            data: data,
                            trigger: true
                        }
                    }
                })];
            case 1:
                extData = (_a.sent()).extData;
                localPath = extData[0];
                return [2 /*return*/, localPath];
        }
    });
}); };
export var localPathToBase64 = function (localPath) { return __awaiter(void 0, void 0, void 0, function () {
    var extData, type, base64Data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, exec('localPathToBase64', {
                    V1: V1,
                    validParams: {
                        params: {
                            localPath: localPath,
                            trigger: true
                        }
                    }
                })];
            case 1:
                extData = (_a.sent()).extData;
                type = extData[0], base64Data = extData[1];
                return [2 /*return*/, "data:image/" + type + ";base64," + base64Data];
        }
    });
}); };
export var saveImageToAlbum = function (params) {
    return exec('saveImageToAlbum', {
        V1: V1_2_0,
        validParams: {
            params: __assign(__assign({}, params), { trigger: true })
        }
    }).then(function () {
        return;
    });
};
export var copyToClipboard = function (text) {
    return exec('copyToClipboard', {
        V1: V1_3_0,
        validParams: {
            params: {
                text: text,
                trigger: true
            }
        }
    }).then(function () {
        return;
    });
};
export var loginRequest = function (phone, verifyCode) {
    return exec('loginRequest', {
        V1: V1_4_0,
        validParams: {
            params: {
                phone: phone,
                verifyCode: verifyCode,
                trigger: true
            }
        }
    }).then(function () {
        return getUserInfo();
    });
};
export var getNetworkInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
    var networkInfo;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, exec('getNetworkInfo', {
                    V1: V1_6_0,
                    validParams: {
                        params: {
                            trigger: true
                        }
                    }
                })];
            case 1:
                networkInfo = _a.sent();
                return [2 /*return*/, networkInfo];
        }
    });
}); };
export var canQuickLogin = function () { return __awaiter(void 0, void 0, void 0, function () {
    var canQuickLoginResult;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, exec('canQuickLogin', {
                    V1: V1_8_1,
                    validParams: {
                        params: {
                            trigger: true
                        }
                    }
                })];
            case 1:
                canQuickLoginResult = _a.sent();
                return [2 /*return*/, canQuickLoginResult];
        }
    });
}); };
export var setStatusBarTextColor = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var trigger, err;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                trigger = params.trigger;
                return [4 /*yield*/, exec('setStatusBarTextColor', {
                        V1: V1_9_0,
                        validParams: {
                            params: params
                        }
                    }).catch(function (errInfo) {
                        return errInfo;
                    })];
            case 1:
                err = (_a.sent()).err;
                trigger(err);
                return [2 /*return*/];
        }
    });
}); };
export var openFullScreenVideo = function (params) {
    runUniqueApi('openFullScreenVideo', params);
};
export var isInstalled = function (platform) { return __awaiter(void 0, void 0, void 0, function () {
    var shareList, _a, response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getShareList()];
            case 1:
                shareList = _b.sent();
                return [2 /*return*/, !!shareList.find(function (installedPlatform) { return platform === installedPlatform; })];
            case 2:
                _a = _b.sent();
                response = _a.response;
                return [2 /*return*/, false];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var runUniqueApi = function (name, params, namespace) {
    if (namespace === void 0) { namespace = ''; }
    var trigger = params.trigger;
    if (params.callback) {
        trigger = params.callback;
    }
    exec(name, {
        V0: V0,
        oldValidParams: {
            params: params
        }
    }, name, namespace).then(function (response) {
        var extData = response.extData;
        trigger.apply(void 0, __spreadArrays([ERRORS.NULL], extData));
    }).catch(function (errInfo) {
        trigger(errInfo.err);
    });
};
export var runOldApi = function (name, params) {
    console.warn('please use runUniqueApi instead');
    runUniqueApi(name, params);
};
export var showNetworkErrorView = function (params) {
    runUniqueApi('refreshStateView', __assign({ state: REFRESH_STATE.NETWORK_ERROR }, params));
};
export var showLoadingErrorView = function (params) {
    runUniqueApi('refreshStateView', __assign({ state: REFRESH_STATE.LOADING_ERROR }, params));
};
export var showLoadingView = function () {
    runUniqueApi('refreshStateView', {
        state: REFRESH_STATE.LOADING
    });
};
export var hideLoadingView = function () {
    runUniqueApi('refreshStateView', {
        state: REFRESH_STATE.HIDE
    });
};
export var jumpNotifyConfig = function (params) {
    runUniqueApi('jumpNotifyConfig', params);
};
export var getNotifyStatus = function (params) {
    runUniqueApi('getNotifyStatus', params);
};
export var updateVipStatus = function (params) {
    runUniqueApi('shareInviteExchanged', params);
};
export var pointUpdate = function (params) {
    runUniqueApi('pointUpdate', params);
};
/* android完成加载 */
if (isAndroid()) {
    jsLoadComplete({});
}
